import React, { useContext, useState } from "react";
import { VersionContext } from "./VersionContext";
import { Dialog } from "primereact/dialog";
import update from '../assets/animations/update.json'
import Lottie from "lottie-react";
import { Button } from "primereact/button";

const UpdateBanner = ({visible, setVisible}) => {

    const refreshPage = () => {
        window.location.reload(true); // Force refresh
    };

    return (
    //    <>
    //    {visible && <div style={{ position: "fixed", bottom: 0, width: "100%", background: "red", color: "white", padding: "10px", textAlign: "center", zIndex: 1000 }}>
    //         A new version is available. <button onClick={refreshPage} style={{ marginLeft: "10px", padding: "5px 10px", background: "white", color: "red", border: "none", cursor: "pointer" }}>Refresh</button>
    //     </div> }
    //    </>
    <div style={{position:"fixed"}}>
        <Dialog
            header="Update available"
            visible={visible}
            style={{ width: "30vw" }}
            onHide={() => setVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={update}
                    loop={true}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />
                <br/>

                <h3 style={{color:"#6e6e6eff"}}>A new Portal version is available, please reload to apply changes.</h3>
                <p style={{color:"#6e6e6eff", fontWeight:600, fontStyle:"bold"}}>If you are unable to reload Portal now, please close & refresh the tab when possible</p>
                <br/>
                <br/>

                <Button label="Reload Portal" icon="pi pi-sync" rounded severity="primary" onClick={() => {
                    setVisible(false)
                    refreshPage()
                }}/>
            </div>
        </Dialog>
    </div>
     
    )
};

export default UpdateBanner;